import type { ImageSet } from "@b2bportal/core-themes";
import activitiesHomepageImage from "../assets/images/activities-homepage-image.svg";
import carsHomepageImage from "../assets/images/cars-illustration.svg";
import homepageImage from "../assets/images/homepage-image.svg";
import hotelLoadingImage from "../assets/images/hotel-bed.svg";
import flightLoadingImage from "../assets/images/loading-image.svg";
import logo from "../assets/images/logo.svg";
import hotelPlaceholder from "../assets/images/placeholders/hotels-trips.webp";
import roomPlaceholder from "../assets/images/placeholders/no-room-image.svg";
import packagePlaceholder from "../assets/images/placeholders/packages-my-trips.svg";

export const images: ImageSet = {
  hotelLoadingImage,
  logo,
  homepageImage,
  carsHomepageImage,
  activitiesHomepageImage,
  tripsLoadingImage: "https://fakeimg.ryd.tools/600x400",
  tripsHeadingBackground:
    "https://fakeimg.ryd.tools/800x200/?text=Wide%20Image",
  roomPlaceholder,
  hotelPlaceholder,
  packagePlaceholder,
  flightLoadingImage,
};

export default images;
